export const ServicesMixin = {
  data() {
    return {
      activeServices: [],
      monthlyTotalCost: 0,
      yearlyTotalCost: 0
    }
  },
  computed: {
    totalMonthPrice() {
      return this.monthlyTotalCost
    },
    totalAnnualPrice() {
      return this.yearlyTotalCost
    }
  },

  methods: {
    calculateTotals(resetValues) {
      if (resetValues) {
        this.monthlyTotalCost = 0
        this.yearlyTotalCost = 0
      }

      this.activeServices.forEach(({ totals }) => {
        if (!totals) return
        this.monthlyTotalCost += totals.Month || 0
        this.yearlyTotalCost += totals.Annual || 0
      })
    },
    addCompanyTotals(companyService) {
      if (
        companyService &&
        companyService.ratePlans &&
        companyService.ratePlans.length
      ) {
        const { totals } = companyService.ratePlans[0]
        this.monthlyTotalCost += totals.Month || 0
        this.yearlyTotalCost += totals.Annual || 0
      }
    }
  }
}
